(function () {
  'use strict';

  function init() {
    var container = document.getElementById('fab-container');
    var trigger   = document.getElementById('fab-trigger');
    // Every trigger that should open the Tawk.to widget, not just the FAB's
    // own "Live Chat" action — e.g. the top bar's Chat/Message icon
    // (sections/announcement-v2.liquid) shares this same class.
    var chatBtns  = document.querySelectorAll('.js-open-tawk-chat');

    if (!container || !trigger) return;

    function isOpen() {
      return container.classList.contains('fab-container--open');
    }

    function open() {
      container.classList.add('fab-container--open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      container.classList.remove('fab-container--open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen() ? close() : open();
    });

    document.addEventListener('click', function (e) {
      if (isOpen() && !container.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    if (chatBtns.length) {
      var tawkReady = false;

      function openTawk() {
        if (typeof Tawk_API !== 'undefined' && typeof Tawk_API.maximize === 'function') {
          Tawk_API.maximize();
        }
      }

      function hideTawk() {
        setTimeout(function () {
          if (typeof Tawk_API !== 'undefined' && typeof Tawk_API.hideWidget === 'function') {
            Tawk_API.hideWidget();
          }
        }, 300);
      }

      function loadTawk() {
        if (tawkReady) { openTawk(); return; }

        // Set all callbacks BEFORE injecting the script so they're ready at init time
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();

        window.Tawk_API.onLoad = function () {
          tawkReady = true;
          Tawk_API.maximize();
        };

        // Both events cover closing: minimized = bubble shown, ended = chat session closed
        window.Tawk_API.onChatMinimized = hideTawk;
        window.Tawk_API.onChatEnded     = hideTawk;

        var s = document.createElement('script');
        s.src = 'https://embed.tawk.to/65bbf0d70ff6374032c7d8fc/1hlj2pgj0';
        s.async = true;
        s.charset = 'UTF-8';
        s.setAttribute('crossorigin', '*');
        document.head.appendChild(s);
      }

      chatBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          close();
          loadTawk();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
